import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { useParams } from 'react-router'
import Card from '../../common/Card'
import './PaymentPlan.css'
import { Button, Spin, Checkbox } from 'antd'
import { clinicTypes, COUNTRY_CODES, routes } from '../../../consts'
import $t from '../../../i18n'
import UnsupportedStateDialog from '../dialogs/UnsupportedStateDialog'
import MedcareOrMedcaidCheckDialog from '../dialogs/MedcareOrMedicaidCheckDialog/MedcareOrMedicaidCheckDialog'
import { PlusOutlined } from '@ant-design/icons'
import config from '../../../config.json'
import moment from 'moment'
import UserExistsDialog from '../dialogs/UserExisitsDialog/UserExistsDialog'
import Dialog from '../../common/Dialog'
import { getValidationErrors } from './Validations/PaymentPlanValidations'
import PaymentPlanForm from './PaymentPlanForm/PaymentPlanForm'
import PhoneImage from '../../../resources/Phone.svg'
import CardsImage from '../../../resources/Cards.svg'
import DoctorImage from '../../../resources/DoctorAvatar.svg'
import { event, eventTypes } from '../../../consts/eventConsts'
import { formatClientSideError } from '../../../utils/eventUtils'
import packageJson from '../../../../package.json'
import { t } from '@transifex/native'

const PaymentPlan = ({ isFormOnly = false }) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const maxDOB = moment().subtract(19, 'years').format('YYYY/MM/DD')
  const { isPlanLoading, shouldDisplaySuccessDialog } = useSelector(
    state => state?.payment
  )
  const selectedPlan = useSelector(state => state.payment?.selectedPlan?.[0])
  const isLoadingCheckoutPage = useSelector(
    state => state?.payment?.isLoadingCheckoutPage
  )
  const urlParams = useSelector(state => state.signup?.urlParams)

  const [phoneNumber, setPhoneNumber] = useState({
    short: 'US',
    code: COUNTRY_CODES[0],
    phone: '',
  })
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [confirmEmail, setConfirmEmail] = useState('')
  const [state, setState] = useState(null)
  const [dob, setDob] = useState(null)
  const [showUnderAgeDialog, setShowUnderAgeDialog] = useState(false)
  const [isStateValid, setIsStateValid] = useState(true)
  const [isPayNow, setIsPayNow] = useState(true)
  const [shouldValidate, setShouldValidate] = useState(false)
  const [unsupportedDialog, setUnsupportedDialog] = useState(false)
  const [giftRecipientFirstName, setGiftRecipientFirstName] = useState()
  const [giftRecipientLastName, setGiftRecipientLastName] = useState()
  const [giftRecipientEmail, setGiftRecipientEmail] = useState()
  const [phoneCodeInput, setPhoneCodeInput] = useState(false)
  const [giftRecipientConfirmEmail, setGiftRecipientConfirmEmail] = useState()
  const [giftRecipientPhoneNo, setGiftRecipientPhoneNo] = useState({
    short: 'US',
    code: COUNTRY_CODES[0],
    phone: '',
  })
  const [enableButton, setEnableButton] = useState(false)
  const [turnToolTip, setTurnToolTip] = useState(false)
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
  const { isPPFUserAlreadyExist } = useSelector(state => state.payment)
  const phoneIsValid = useSelector(state => state.payment.phoneIsValid)
  const [isAgreeToTerms, setIsAgreeToTerms] = useState(false)

  //PPF and Gifting flags
  const isGifting = selectedPlan?.is_gifting
  const isPPF = selectedPlan?.is_ppf
  const isWithoutPaymentFlow = selectedPlan?.is_without_payment

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(Actions.createAction(Actions.SIGNOUT_REQUESTED))
      window.location.reload()
    }
    //gets Plan Details according to id
    dispatch(Actions.createAction(Actions.PAYMENT_PLAN_REQUESTED, { id }))
    // gets the list of valid states
    dispatch(
      Actions.createAction(Actions.SUBSCRIPTION_VALIDATE_STATE_REQUESTED, {
        state: 'NY',
      })
    )
    dispatch(Actions.createAction(Actions.INVOKE_PPF_ORDER))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isPPF && !isGifting) {
      if (selectedPlan?.clinic === clinicTypes.HTN) {
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'landing_page_visit_htn',
            data: { profileId: null },
          })
        )
      } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'landing_page_visit_mh',
            data: { profileId: null },
          })
        )
      }
    }
    if (isPPF || isGifting) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_landing_page_visit',
          data: {
            planName: selectedPlan?.plan_name,
            planId: selectedPlan?.id,
          },
        })
      )
    }
  }, [selectedPlan])

  const renderBanner = () => (
    <div className="payment-plan-banner">
      <div className="payment-plan-banner-image">
        <img src={selectedPlan?.plan_image} alt="" />
      </div>
      <div className="payment-plan-banner-description">
        <div className="payment-plan-title-description">
          <h2>
            {t(selectedPlan?.title)}
            <br />
            {selectedPlan?.discounted_price && (
              <s>{`$${selectedPlan?.discounted_price}`}</s>
            )}{' '}
            ${selectedPlan?.price}
            {selectedPlan?.show_terms && '/month'}
          </h2>
          <p className="selected-plan-body">{t(selectedPlan?.body)}</p>
        </div>
        {!isGifting && !isPPF && (
          <div className="payment-plan-sub-description">
            <PlusOutlined className="plus" />
            <p>{$t('pages.paymentplan.walnutDesc')}</p>
          </div>
        )}
      </div>
    </div>
  )
  const renderBenefitsCard = () => (
    <div className="payment-plan-benefit-container">
      <Card>
        <div className="payment-plan-benefit-card">
          <h4 className="payemnt-heading">{t(selectedPlan?.bullet_title)}</h4>
          <ul>{renderCardBullets()}</ul>
        </div>
      </Card>
    </div>
  )
  const howItWorksObj = [
    {
      image: PhoneImage,
      text: $t('pages.paymentplan.howItWorks.signUp'),
    },
    {
      image: CardsImage,
      text: $t('pages.paymentplan.howItWorks.payForVisit'),
    },
    {
      image: DoctorImage,
      text: $t('pages.paymentplan.howItWorks.AnswerClinician'),
    },
  ]

  const renderInstructionCard = (imageURL, index, text) => (
    <div className="ppf-how-it-works-card">
      <div className="ppf-how-it-works-card-image-container">
        <img
          className="ppf-how-it-works-card-image"
          src={imageURL}
          alt="howItWorks"
        />
      </div>
      <div className="ppf-how-it-works-card-text-container">
        <span className="ppf-how-it-works-card-text">
          {index}. {text}
        </span>
      </div>
    </div>
  )

  const renderInstructionsCardContainer = () => (
    <div className="payment-plan-benefit-container ppf-hiw-parent-container">
      <Card className="ppf-how-it-works-container">
        <div className="ppf-how-it-works-headline-container">
          <span className="ppf-how-it-works-headline">How it works</span>
        </div>
        {howItWorksObj.map((item, index) =>
          renderInstructionCard(item.image, index + 1, item.text)
        )}
      </Card>
    </div>
  )

  const renderTermsAndConditionsStatement = () => (
    <div className="terms-and-conditions-statement">
      {isWithoutPaymentFlow && (
        <div>
          <Checkbox
            className="terms-checkbox"
            onChange={() => setIsAgreeToTerms(!isAgreeToTerms)}
            checked={isAgreeToTerms}
          />
          {$t('pages.paymentplan.agreeToSmsAndWithThe')}
        </div>
      )}
      {!isWithoutPaymentFlow &&
        $t('pages.paymentplan.byContinueYouAgreeWithThe')}
      <a
        href={config.termsURL}
        rel="noreferrer"
        target="_blank"
        className="signin-form-tandc"
      >
        {$t('pages.paymentplan.terms')}
      </a>

      {selectedPlan?.show_terms ? ', ' : $t('pages.paymentplan.andShort')}
      <a
        href={config.privacyURL}
        target="_blank"
        rel="noreferrer"
        className="signin-form-privacy-policy"
      >
        {$t('pages.getStarted.signinForm.privacyPolicy')}
      </a>
      {selectedPlan?.show_terms && ' ' + $t('pages.paymentplan.and')}
      {selectedPlan?.show_terms && (
        <a
          href={isPPF ? config.plansTermsURL : config.planSubscriptionURL}
          target="_blank"
          rel="noreferrer"
          className="signin-form-privacy-policy"
        >
          {$t('pages.paymentplan.subscriptionTerms')}.
        </a>
      )}
    </div>
  )

  const renderGiftingTermsAndConditionsStatement = () => (
    <div className="terms-and-conditions-statement">
      {$t('pages.paymentplan.giftingDisclaimer')}
      <a
        href={config.giftingTermsURL}
        rel="noreferrer"
        target="_blank"
        className="signin-form-tandc"
      >
        {$t('pages.paymentplan.giftTerms')}
      </a>
    </div>
  )

  const renderCardBullets = () =>
    selectedPlan?.external_bullets?.map((item, index) => (
      <li className="card-bullets" key={index}>
        {t(item)}
      </li>
    ))

  const checkIsUserHaveSubscriptions = () => {
    dispatch(
      Actions.createAction(
        Actions.CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_REQUESTED,
        {
          selectedPlanId: id,
          planName: selectedPlan?.plan_name,
        }
      )
    )
  }

  const handleContinue = () => {
    let onClickHandler = onHandleValidations
    if (phoneIsValid) {
      onClickHandler = onPPFNext
    }

    return (
      <div
        className={`${!isPPF && 'bnpl-btn-container '} ${
          isPPF && 'ppf-btn-container'
        }`}
      >
        {renderTermsAndConditionsStatement()}
        {!isWithoutPaymentFlow && (
          <Button
            type="primary"
            onClick={onClickHandler}
            disabled={isLoadingCheckoutPage || phoneCodeInput}
            loading={isLoadingCheckoutPage}
          >
            {phoneIsValid
              ? $t('pages.paymentplan.next')
              : $t('pages.paymentplan.continue')}
          </Button>
        )}
        {isWithoutPaymentFlow && (
          <Button
            type="primary"
            onClick={onClickHandler}
            disabled={
              !isAgreeToTerms || phoneCodeInput || isLoadingCheckoutPage
            }
            loading={isLoadingCheckoutPage}
          >
            {phoneIsValid
              ? $t('pages.paymentplan.next')
              : $t('pages.paymentplan.continue')}
          </Button>
        )}
      </div>
    )
  }

  const handleGiftingMVPContinue = () => (
    <div
      className={`${!isGifting && 'bnpl-btn-container '} ${
        isGifting && 'ppf-btn-container'
      }`}
    >
      {renderGiftingTermsAndConditionsStatement()}
      <Button
        type="primary"
        onClick={phoneIsValid ? onGiftingMVPNext : onHandleValidations}
        disabled={isLoadingCheckoutPage || phoneCodeInput}
        loading={isLoadingCheckoutPage}
      >
        {phoneIsValid
          ? $t('pages.paymentplan.next')
          : $t('pages.paymentplan.continue')}
      </Button>
    </div>
  )

  const validAge = date => {
    const age = moment().diff(date, 'years')
    return age >= config.minimalAdultAge
  }
  const errors =
    shouldValidate &&
    getValidationErrors({
      isPPF,
      isGifting,
      phoneNumber: phoneNumber.phone,
      email,
      confirmEmail,
      firstName,
      lastName,
      state: state?.label,
      isPayNow,
      dob,
      giftRecipientFirstName,
      giftRecipientLastName,
      giftRecipientEmail,
      giftRecipientConfirmEmail,
      giftRecipientPhoneNo: giftRecipientPhoneNo.phone,
    })
  const onHandleValidations = () => {
    const validationErrors = getValidationErrors({
      isPPF,
      isGifting,
      phoneNumber: phoneNumber.phone,
      email,
      confirmEmail,
      firstName,
      lastName,
      state: state?.label,
      isPayNow,
      dob,
      giftRecipientFirstName,
      giftRecipientLastName,
      giftRecipientEmail,
      giftRecipientConfirmEmail,
      giftRecipientPhoneNo: giftRecipientPhoneNo.phone,
    })
    if (isPPF && !isGifting) {
      let valid = validAge(dob)
      if (!valid) {
        setShowUnderAgeDialog(true)
        return
      }
    }
    if (validationErrors) {
      setShouldValidate(true)
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.invalid,
          data: {
            selectedPlan: id,
            firstName,
            lastName,
            email,
            state,
            phoneNumber: phoneNumber?.phone,
            dob,
          },
          element: 'ppf_form',
          error: formatClientSideError(validationErrors),
        })
      )
      return
    }
    if (isPPF || isGifting) {
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          eventName: 'ppf_landing__submitted',
          data: {
            planName: selectedPlan?.plan_name,
            planId: selectedPlan?.id,
            email: email,
          },
        })
      )
    }
    if (!isPPF && !isGifting) {
      dispatch(
        Actions.createAction(Actions.PAYMENT_PLAN_UPDATED, {
          selectedPlan,
          isPayNow,
        })
      )
    }

    if (isStateValid) {
      if (isPPF && !isGifting) {
        dispatch(Actions.createAction(Actions.REQUEST_MEDICARE_DIALOG))
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'ppf_supported_state',
            data: {
              planName: selectedPlan?.plan_name,
              planId: selectedPlan?.id,
              state: state?.label,
            },
          })
        )
      } else if (isGifting) {
        dispatch(
          Actions.createAction(
            Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF,
            {
              selectedPlan: id,
              firstName,
              lastName,
              email,
              state: state?.label,
              phoneNumber: `+${phoneNumber.code}${phoneNumber.phone}`,
              source: 'ppf',
              isGiftingMVP: isGifting,
              selectedPlanObj: selectedPlan,
            }
          )
        )
      }
      if (isGifting) {
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'ppf_supported_state',
            data: {
              planName: selectedPlan?.plan_name,
              planId: selectedPlan?.id,
              state: state?.label,
            },
          })
        )
      }
      if (!isPPF && !isGifting) {
        if (selectedPlan?.clinic === clinicTypes.HTN) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'state_supported_yes_htn',
              data: {
                selectedState: state?.label,
              },
            })
          )
        } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'state_supprted_yes_mh',
              data: {
                selectedState: state?.label,
              },
            })
          )
        }
      }
    } else {
      setUnsupportedDialog(true)
      if (isPPF || isGifting) {
        dispatch(
          Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
            eventName: 'ppf_unsupported_state',
            data: {
              planName: selectedPlan?.plan_name,
              planId: selectedPlan?.id,
              state: state?.label,
            },
          })
        )
      }
      if (!isPPF && !isGifting) {
        if (selectedPlan?.clinic === clinicTypes.HTN) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'state_supported_no_htn',
              data: {
                selectedState: state?.label,
              },
            })
          )
        } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'state_supprted_no_mh',
              data: {
                selectedState: state?.label,
              },
            })
          )
        }
      }

      let userData = {
        first_name: firstName,
        username: email,
        state: state?.label,
        phoneNumber: phoneNumber?.phone,
      }
      dispatch(
        Actions.createAction(Actions.REQUEST_NON_SUPPORTED_STATE, userData)
      )
    }
  }
  const onSubmit = () => {
    dispatch(Actions.createAction(Actions.REQUEST_CLOSE_MEDICARE_DIALOG))
    if (isPPF) {
      sendVerificationCode()
      setPhoneCodeInput(true)
    }
    if (isGifting) {
    }
    if (!isPPF && !isGifting) {
      if (isPayNow) {
        if (selectedPlan?.clinic === clinicTypes.HTN) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'stripe_selected_htn',
            })
          )
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'landing_page_submitted_htn',
            })
          )
        } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'stripe_selected_mh',
            })
          )
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'landing_page_submitted_mh',
            })
          )
        }
        dispatch(
          Actions.createAction(Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED, {
            selectedPlan: id,
            firstName,
            lastName,
            email,
            state: state?.label,
            phoneNumber: phoneNumber?.phone,
          })
        )
      } else if (!isPayNow) {
        if (selectedPlan?.clinic === clinicTypes.HTN) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'walnut_selected_htn',
            })
          )
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'landing_page_submitted_htn',
            })
          )
        } else if (selectedPlan?.clinic === clinicTypes.MENTAL) {
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'walnut_selected_mh',
            })
          )
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              eventName: 'landing_page_submitted_mh',
            })
          )
        }
        dispatch(
          Actions.createAction(Actions.CHECKOUT_WALNUT_NO_MEMBER_REQUESTED, {
            selectedPlan: id,
            firstName,
            lastName,
            email,
            state: state?.label,
            phoneNumber: phoneNumber?.phone,
            plan: selectedPlan,
          })
        )
      }
    }
  }

  const onPPFNext = () => {
    dispatch(
      Actions.createAction(Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF, {
        selectedPlan: id,
        firstName,
        lastName,
        email,
        state: state?.label,
        phoneNumber: `+${phoneNumber.code}${phoneNumber.phone}`,
        dob,
        source: 'ppf',
        isGiftingMVP: isGifting,
        stateCode: state?.isoCode,
        selectedPlanObj: selectedPlan,
        element: 'ppf-form',
      })
    )
  }

  const onGiftingMVPNext = () => {
    dispatch(
      Actions.createAction(Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF, {
        selectedPlan: id,
        firstName,
        lastName,
        email,
        state: state?.label,
        phoneNumber: `+${phoneNumber.code}${phoneNumber.phone}`,
        dob,
        source: 'ppf',
        isGiftingMVP: isGifting,
        stateCode: state?.value,
        selectedPlanObj: selectedPlan,
      })
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'ppf_landing__submitted',
        data: {
          planName: selectedPlan?.plan_name,
          planId: selectedPlan?.id,
          email: email,
        },
      })
    )
  }

  const sendVerificationCode = async () => {
    window.document.cookie = 'antidote=antidote;'
    dispatch(
      Actions.createAction(Actions.CHECK_PPF_PLAN_EMAIL_AND_PHONE_REQUESTED, {
        email: email,
        urlParams: urlParams,
        phoneNumber: `+${phoneNumber.code}${phoneNumber.phone}`,
        planName: selectedPlan?.plan_name,
        element: 'ppf-phone-verification',
      })
    )

    setEnableButton(false)
    setTimeout(() => {
      setEnableButton(true)
    }, 10000)
  }

  const handleSignIn = () => {
    dispatch(Actions.createAction(Actions.PAYMENT_SUCCESS_ALERT_ACKNOWLEDGED))
    const otp_login_page = `${window.location.origin}${packageJson.homepage}${routes.ONE_TIME_LOGIN}`
    window.top.location.href = otp_login_page // go out from the iFrame
  }

  return (
    <>
      {isPlanLoading && <Spin size="large" />}
      {!isPlanLoading && (
        <div className="payment-plan-page-container">
          {!isFormOnly && renderBanner()}
          <div
            className="payment-plan-main-container"
            data-just-form={isFormOnly}
          >
            {!isFormOnly && (
              <div>
                {renderBenefitsCard()}
                {renderInstructionsCardContainer()}
              </div>
            )}
            <PaymentPlanForm
              errors={errors}
              firstName={firstName}
              setFirstName={setFirstName}
              lastName={lastName}
              setLastName={setLastName}
              email={email}
              setEmail={setEmail}
              confirmEmail={confirmEmail}
              setConfirmEmail={setConfirmEmail}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              state={state}
              setState={setState}
              dob={dob}
              setDob={setDob}
              turnToolTip={turnToolTip}
              setTurnToolTip={setTurnToolTip}
              isPayNow={isPayNow}
              setIsPayNow={setIsPayNow}
              handleContinue={handleContinue}
              handleGiftingMVPContinue={handleGiftingMVPContinue}
              setIsStateValid={setIsStateValid}
              sendVerificationCode={sendVerificationCode}
              setPhoneCodeInput={setPhoneCodeInput}
              enableButton={enableButton}
              shouldValidate={shouldValidate}
              giftRecipientFirstName={giftRecipientFirstName}
              setGiftRecipientFirstName={setGiftRecipientFirstName}
              giftRecipientLastName={giftRecipientLastName}
              setGiftRecipientLastName={setGiftRecipientLastName}
              giftRecipientEmail={giftRecipientEmail}
              setGiftRecipientEmail={setGiftRecipientEmail}
              giftRecipientConfirmEmail={giftRecipientConfirmEmail}
              setGiftRecipientConfirmEmail={setGiftRecipientConfirmEmail}
              giftRecipientPhoneNo={giftRecipientPhoneNo}
              setGiftRecipientPhoneNo={setGiftRecipientPhoneNo}
              customHeader={
                isWithoutPaymentFlow
                  ? $t('pages.paymentplan.form.takeFirstStep')
                  : null
              }
            />
          </div>
        </div>
      )}
      <UnsupportedStateDialog
        state={state?.isoCode}
        unsupportedDialog={unsupportedDialog}
        setUnsupportedDialog={setUnsupportedDialog}
      />
      <UserExistsDialog />
      <Dialog
        title={$t('pages.getStarted.signupForm.errors.underAgeTitle')}
        isVisible={showUnderAgeDialog}
        footerActions={[
          <Button type="primary" onClick={() => setShowUnderAgeDialog(false)}>
            {$t('pages.getStarted.signupForm.gotIt')}
          </Button>,
        ]}
        closable={true}
        onCancel={() => setShowUnderAgeDialog(false)}
      >
        <div className="underage-text">
          {$t('pages.getStarted.signupForm.errors.underAgeText')}
        </div>
      </Dialog>
      {isFormOnly && (
        <Dialog
          title={$t('pages.successV2.congratulations')}
          isVisible={shouldDisplaySuccessDialog}
          footerActions={[
            <Button type="primary" onClick={handleSignIn}>
              {$t('pages.successV2.signInToGetStarted')}
            </Button>,
          ]}
          closable={false}
        >
          <div className="success-text">
            {selectedPlan?.ppf_success_message}
          </div>
        </Dialog>
      )}
      {!isGifting && <MedcareOrMedcaidCheckDialog handleSubmit={onSubmit} />}
    </>
  )
}
export default PaymentPlan
